var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SortableTable',{attrs:{"rows":_vm.computedResources,"headers":_vm.resourceHeaders,"table-actions":false,"row-actions":false,"key-field":"tableKey","default-sort-by":"state","paged":true}})}
var staticRenderFns = []

export { render, staticRenderFns }